.mytakenphoto {
    width: 20px;
    height: 20px;
    /*
    z-index: 9;
    position: absolute;
    */
  }
  .mycamm {
    width: 20px;
    height: 20px;
    /*z-index: -3;*/ /* not in effect */
    /*position: absolute;*/
  }
